import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFaroeIslands = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_67)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.4783 12L23.8983 10.4348C23.8285 9.90131 23.7239 9.37875 23.5867 8.86959H10.9565V0.0456543C10.424 0.0914981 9.90161 0.172545 9.39133 0.285701L7.30436 1.5652L6.26087 1.45987C5.71173 1.7595 5.18856 2.10075 4.69567 2.47945V8.86954H0.413401C0.276198 9.3787 0.171573 9.90126 0.101823 10.4347L0.521729 12L0.101776 13.5652C0.171526 14.0987 0.276151 14.6213 0.413354 15.1304H4.69562V21.5205C5.18851 21.8993 5.71173 22.2405 6.26082 22.5401L7.82603 22.4347L9.39123 23.7142C9.90156 23.8274 10.424 23.9084 10.9564 23.9543V15.1305H23.5865C23.7237 14.6213 23.8284 14.0987 23.8981 13.5652L23.4783 12Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.8984 10.4348H9.39136H9.39131V0.285233C8.28234 0.531139 7.23098 0.929717 6.26086 1.45908V10.4348H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5305 0.034875 13.0529 0.101578 13.5652H6.26081H6.26086V22.5409C7.23098 23.0702 8.28234 23.4689 9.39131 23.7147V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5305 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_67",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgFaroeIslands;
